import { UntypedFormGroup } from '@angular/forms';
import { Interkassa } from './form-filler.interkassa';
import { InterkassaPaymentIq } from './form-filler.interkassa-paymentiq';
import { UserFullInfo, UserInfo } from 'src/app/services/auth/login/login.models';
import { PixAstropayCard } from './form-filler.pix';

export interface DepositFormFiller {
    fillForm(form: UntypedFormGroup, userInfo: UserFullInfo)
}

class Dummy implements DepositFormFiller {
    public fillForm(form: UntypedFormGroup, userInfo: UserFullInfo) {
        return
    }
}

const fillerMap = {
    "INTERKASSA CARD VISA": Interkassa,
    "INTERKASSA CARD MASTERCARD": Interkassa,
    "paymentiq": InterkassaPaymentIq,
    "pix": PixAstropayCard,
    dummy: Dummy
};
type Keys = keyof typeof fillerMap; // 'dev' | 'manager'
type fillerTypes = typeof fillerMap[Keys]; //typeof Developer | typeof Manager
type ExtractInstanceType<T> = T extends new () => infer R ? R : never;

export class FormFillerFactory {
    static getFiller(paymentName: string): ExtractInstanceType<fillerTypes> {
        if (fillerMap.hasOwnProperty(paymentName)) {
            return new fillerMap[paymentName]();
        }
        else {
            return new fillerMap['dummy']();
        }
    }
}



